export var EXTERNAL_FILE_STORAGE_REPOSITORY = 'EXTERNAL_FILE_STORAGE_REPOSITORY';